import React, {Component} from 'react';
import {Modal, ModalHeader, ModalBody, Button} from 'reactstrap';
import SyntaxHighlighter from 'react-syntax-highlighter/prism';
import { prism } from 'react-syntax-highlighter/styles/prism';

//style
import '../../../css/displayCode.css';

class DisplayCode extends Component {

    constructor(props) {
        super(props);

        this.state = {
            isOpen: props.showModal
        };

        this.toggleModal = this.toggleModal.bind(this);
    }

    componentWillReceiveProps(newProps) {
        this.setState({
            isOpen: newProps.showModal
        });
    }

    toggleModal() {
        if(this.state.isOpen) {
            //notify parent that modal is closed
            this.props.closeModalHandler();
        }
        else {
            this.setState({isOpen: !this.state.isOpen});
        }
    }

    renderDownloadIcon(submission)
    {
        var templateFile = "data:application/octet-stream," + encodeURIComponent(submission.sourceFile);
        var filename = submission.extension.substring(submission.extension.indexOf('/')+1);

        return (
            <a href={templateFile}
               download = {filename} className="default-link">
                <Button> <span className="fa fa-cloud-download" ></span> Preuzmi kod </Button>
            </a>
        );

    }

    render() {
        var submission = this.props.submission;
        if(submission === null || submission.sourceFile === null)
        {
            return (<div></div>);
        }

        return (
            <Modal isOpen={this.state.isOpen} toggle={this.toggleModal} className="displayCodeModal">
                <ModalHeader toggle={this.toggleModal}>
                    <h4>Pregled koda </h4>
                </ModalHeader>
                <ModalBody className="displayCodeModalBody">
                    <div className="row">
                        <div className="col-10 displayCodeModalBodyColumn offset-1">
                            <h4> Kod </h4>
                            <div className="row">
                                <p className="col-6 no-bottom-margin"> Ovo rešenje je prošlo {submission.score}% test primera.</p>
                                <p className="col-6 no-bottom-margin" style={{'text-align': 'right'}}> {this.renderDownloadIcon(submission)} </p>
                            </div>
                            <SyntaxHighlighter
                                language='c'
                                style={prism}
                                showLineNumbers={true}
                            >
                                {submission.sourceFile}
                            </SyntaxHighlighter>
                        </div>
                        <div className="col-1 mt-5">
                            {/*{this.renderDownloadIcon(submission)}*/}
                        </div>
                    </div>
                </ModalBody>
            </Modal>
        );
    }
}

export default DisplayCode;
